import { Component } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { HttpAlertService } from 'src/app/services/http-alert.service';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'change-email-details',
    templateUrl: './changeEmail.component.html',
    styleUrls: ['./changeEmail.component.scss']
})
export class ChangeEmailComponent {
    changeEmailForm: FormGroup;
    showCodeModal = false;
    code: string = "";
    isLoading = false;
    codeError = false;

    constructor(private userService: UserService, private formBuilder: FormBuilder, private translate: TranslateService, private alertService: HttpAlertService, private title: Title) {
        this.initForm();
    }

    ngOnInit(): void {
      this.translate.get('title_change_email').subscribe({
        next: (title) => {
          this.title.setTitle(title);
        }
      });
    }

    public initForm(): void{
        this.changeEmailForm = this.formBuilder.group({
          new_email: ['', [Validators.required, Validators.email]],
        });
    }

    public onSubmit() {
      this.isLoading = true;
        this.userService.changeEmail(this.changeEmailForm.value).subscribe(result => {
          if (result.success) {
            this.alertService.success(this.translate.instant(result.message));
            this.showCodeModal = true;
          } else {
            this.alertService.warn(this.translate.instant(result.message));
          }
          this.isLoading = false;
        },
          error => {
            this.isLoading = false;
            this.alertService.error(this.translate.instant(error.error.message));
          }
        );
    }

    public verifyCode() {
      if (this.code.trim().length !== 6) {
        this.codeError = true;
      } else {
        this.codeError = false;
        this.isLoading = true;

        const obj = {
          new_email: this.changeEmailForm.value.new_email,
          code: this.code.trim()
        };

        this.userService.verifyChangeEmailCode(obj).subscribe(response => {
          if (response.success) {
            this.alertService.success(this.translate.instant(response.message));
            this.showCodeModal = false;
            this.initForm();
          }
          this.isLoading = false;
        }, (err) => {
          this.alertService.error(this.translate.instant(err.error.message));
          this.isLoading = false;
        });
      }
    }
}
